class Routing {
  static getQueryParameter(name, url)
  {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static addQueryParameter(name, value, url) {
    if (!url) url = window.location.href;
    let parameter = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    if (Routing.urlHasQuery(url)) {
      return Routing.getUrlWithoutQuery(url) + '?' + parameter + '&' + Routing.getQuery(url);
    }else {
      if (Routing.urlHasHash(url)) {
        return Routing.getUrlWithoutHash(url) + '?' + parameter + '#' + Routing.getHash(url);
      } else {
        return url + '?' + parameter;
      }
    }
  }

  static getUrlWithoutQuery(url) {
    return Routing.urlHasQuery(url) ? url.split('?')[0] : url;
  }

  static getUrlWithoutHash(url) {
    return Routing.urlHasHash(url) ? url.split('#')[0] : url;
  }

  static getQuery(url) {
    return Routing.urlHasQuery(url) ? url.split('?')[1] : '';
  }

  static getHash(url) {
    return Routing.urlHasHash(url) ? url.split('#')[1] : '';
  }

  static urlHasHash(url) {
    if (!url) url = window.location.href;
    return url.indexOf('#') != -1
  }

  static urlHasQuery(url) {
    if (!url) url = window.location.href;
    return url.indexOf('?') != -1
  }
  
}

export default Routing;